module.exports = __webpack_public_path__ + "static/media/data.ff97ade0.svg";